var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpinner = function SvgIconSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 3a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm6.073 3.342a1 1 0 1 0-1.414-1.415L15.54 7.046a1 1 0 1 0 1.414 1.414zM17 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1m-.046 3.54a1 1 0 0 0-1.414 1.414l2.119 2.119a1 1 0 0 0 1.414-1.415zM12 17a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3.54-.046a1 1 0 1 0-1.414-1.414l-2.118 2.119a1 1 0 1 0 1.414 1.414zM2 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m4.342-7.073a1 1 0 0 0-1.414 1.415L7.046 8.46a1 1 0 0 0 1.415-1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpinner;